import {ExternalBackend} from "./ExternalBackend";

export class DummyWorkflow extends ExternalBackend {

  constructor(params) {
    super("dummy", params);
  }
}